<template>
  <notification
    icon="fa-info"
    type="is-info"
    @delete="$emit('delete')"
    snackbar
  >
    Nastąpiło poprawne wylogowanie z panelu administratora.
  </notification>
</template>

<script>
import Notification from "./Notification";

export default {
  name: "sign-out-notification",

  components: {
    Notification
  }
};
</script>

<style></style>
